import moment from 'moment-timezone'

import { PerformanceSimpleListRead } from '@generated/types'

// The performances a Guest can still buy: the pages drop anything before today in the venue's
// timezone, and the structured data must describe what the pages show.
export function upcomingPerformances(
  performances: PerformanceSimpleListRead[] | undefined,
  timezone: string,
): PerformanceSimpleListRead[] {
  // Both sides of the comparison are venue-local. `todayIsoStr()` is the renderer's date, and
  // wherever the SSR container's zone runs ahead of the venue's it would drop a show a Guest can
  // still walk into: 21:00 Central is already tomorrow in UTC.
  const today = moment.tz(timezone).format('YYYY-MM-DD')
  return (performances ?? []).filter(
    performance => moment.tz(performance.datetime, timezone).format('YYYY-MM-DD') >= today,
  )
}
